export function isNotNull(v) {
    return v !== null;
}
export const browserTimeZone = window.Intl.DateTimeFormat().resolvedOptions()
    .timeZone;
